module.exports = __webpack_public_path__ + "img/C537.7396ae3a.jpg";